<!-- drag & drop zone -->
<div class="orto-modal-wrapper">
  <ngx-file-drop [multiple]="multi" [accept]="types?.join(',')" class="drag-drop" [class.full-hight]="isIconShow && (previewFiles.length == 0 || previewFiles == undefined)" [class.zero-hight]="window === 1 && filesInfo.length > 0" dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)">
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">

      <div class="header">
        <h4>{{ "GEODATA.DRAG&DROP_IMAGES" | translate }}</h4>

        <div class="header-icon">

          <div  (click)="openFileSelector()">
            <i [title]="'GLOBAL.UPLOAD' | translate" class="fas fa-upload"></i>
          </div>

          <button type="button" class="close pull-right" aria-label="Close" (click)="hideModal('close')" title="{{'GLOBAL.FERMER' | translate}}">
            <span aria-hidden="true">&times;</span>
          </button>

        </div>
      </div>

      @if (isIconShow && (previewFiles.length == 0 || previewFiles == undefined)) {
        <div  class="icone" (click)="openFileSelector()">
          <i class="fas fa-upload"></i>
        </div>
      }

      @if (window === 2 && previewFiles.length > 0) {
        <div class="files-preview"  [class.hidden]="window === 2" >
          @for (img of previewFiles; track img; let i = $index) {
            <div class="img" (click)="selectImage(i)">
              <input type="checkbox" class="img-checkbox" [checked]="img.isChecked">
              <img [src]="img.fileUrlPreview" [alt]="img.fileName" [title]="img.fileName" >
            </div>
          }
        </div>
      }

    </ng-template>

  </ngx-file-drop>

  <div  class="files-list" [class.hidden]="isIconShow && (previewFiles.length == 0 || previewFiles == undefined)" [class.full-hight]="(window === 1 && filesInfo.length > 0)">

    @if (filesInfo.length > 0) {
      <div class="table">
        @if (filesInfo.length > 0) {
          <div class="icon-menu">
            <p><b>{{filesInfo.length}}</b> photos to process</p>
            <i [title]="'GLOBAL.SUPPRIMER' | translate" class="fas fa-trash-alt trash" (click)="deleteSelectedFilesFromList()"></i>
          </div>
        }
        <table>
          <thead>
            <tr>
              <th></th>
              @for (propriete of proprietesAffichees; track propriete; let i = $index) {
                <th width="{{TH_Width[i] + '%' }}">
                  <div class="table-header-item" style="cursor: pointer">
                    <span>{{ propriete.libelleAffiche | translate }}</span>
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody >
            @for (f of filesInfo; track f; let i = $index) {
              <tr (click)="selectImage(i)" >
                <td><input type="checkbox" [checked]="f.isChecked"></td>
                <td [title]="f.fileName">{{ f.fileName }}</td>
                <td>{{ f.fileSize }}</td>
                <td>{{ f.lastModified }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

  </div>
  <b class="ortho_available">{{ 'ORTHOPHOTOS.AVAILABLE_IN_5_MINUTES' | translate }}</b>
  <div class="footer">
    @if (window === 1 && showErrorMsg()) {
      <span class="msg-errror"><i class="fas fa-exclamation-triangle"></i> {{msgErrorContent()}}</span>
    }
    @if (window === 2 && showErrorMsg()) {
      <span class="msg-errror"><i class="fas fa-exclamation-triangle"></i> {{msgErrorContent()}}</span>
    }
    <div class="footer-body">
      <button type="button" class="btn bg-secondary text-white" (click)="hideModal('close')">{{'GLOBAL.ANNULER' | translate}}</button>

      @if (filesInfo.length > 0 && window === 2) {
        <span class="info-text">
          <span class="left"><i class="fas fa-exclamation-triangle"></i></span>
          <span class="right">
            <span> {{ "GEODATA.MSG_INFO_LINE1" | translate }}</span>
            <span> {{ "GEODATA.MSG_INFO_LINE2" | translate }}</span>
            <span> {{ "GEODATA.MSG_INFO_LINE3" | translate }}</span>
          </span>
        </span>
      }


      <span class="btn-box">

        @if (window === 1) {
          <button  type="button" class="btn btn-outline-success" (click)="uploadOrthoFiles()">{{'GLOBAL.UPLOAD' | translate}}</button>
        }
        <!-- <button *ngIf="window === 2"  type="button" class="btn btn-outline-success" (click)="checkStrayosUpload()">{{'GLOBAL.PROCESS' | translate}}</button> -->
      </span>
    </div>

    <div class="progress">
      <div class="progress-bar" role="progressbar" [ngStyle]="{'width': barValue()}" aria-valuenow="5" aria-valuemin="0" aria-valuemax="100">{{barValue()}}</div>
    </div>

    @if (errorMessage()) {
      <div class="error-message-container">
        <div class="error-message">
          <i class="fas fa-exclamation-triangle"></i>
          <span>{{ errorMessage() }}</span>
          <button type="button" class="error-close-btn" (click)="closeErrorMessage()" title="Fermer">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    }

  </div>

</div>


